import { logerr, loginfo } from './Logging';
import { PhidgetChannel } from './Phidget';
import { Manager } from './Manager';
import { PhidgetConnection } from './Connection';
import { Channel } from './Channel';
import { PhidgetLock } from './PhidgetLock';
import { Device } from './Device';

export const C_LIBRARY_VERSION = "1.19"

/**
 * The base Phidget22 library version for this release - corresponds to the C library version
 * @public
 */
export const LibraryVersion = "Phidget22 - Version " + C_LIBRARY_VERSION + " - Built [VI]{date}[/VI]";
/**
 * The JavaScript library version
 * @public
 */
export const JSLibraryVersion = "[VI]{version} - {date}[/VI]";

export const Managers: Manager[] = [];				/* User Created Managers */
export const Connections: PhidgetConnection[] = [];		/* User Created connections */
export const UserPhidgets: PhidgetChannel[] = [];	/* User Created Phidgets */

let Epoch: number | undefined;
export function tm() {
	if (Epoch == undefined)
		Epoch = Date.now();
	return (Date.now() - Epoch);
}

export async function scanChannels(userphid: PhidgetChannel) {

	for (const conn of Connections) {

		if (userphid._isLocal && conn._isRemote)
			continue;

		if (userphid._isRemote && conn._isLocal)
			continue;

		if (await conn._match(userphid))
			return true;
	}
	return false;
}

export async function scanUserPhidgets(ch: Channel) {

	for (const userphid of UserPhidgets) {
		if (await ch.tryMatchOpen(userphid))
			return;
	}
}

let scanningActive = false;
let scanStopped: (() => void) | undefined;
let scanLock: PhidgetLock;
let scanTimeout: NodeJS.Timer | undefined;

export async function startScanningUserPhidgets() {

	if (!scanLock)
		scanLock = new PhidgetLock();

	await scanLock.acquire();
	if (scanningActive) {
		scanLock.release();
		return;
	}

	const scan = () => {
		scanTimeout = undefined;

		const again = () => {
			// if still scanning, scan again in 1000ms
			if (scanningActive) {
				scanTimeout = setTimeout(scan, 1000);
			} else {
				if (scanStopped) {
					scanStopped();
					scanStopped = undefined;
				}
			}
		};

		// This scans channels on all user phidgets in parallel
		Promise.all(UserPhidgets.filter(userphid => !userphid._attaching && !userphid._isopen).map(userphid => {
			return scanChannels(userphid);
		})).then(() => {
			again();
		}).catch(err => {
			logerr("Error during User Phidgets scan", err);
			again();
		});
	}

	scanningActive = true;
	loginfo("Starting User Phidget scanning");
	scan();
	scanLock.release();
}
export async function stopScanningUserPhidgets() {

	if (!scanLock)
		scanLock = new PhidgetLock();

	await scanLock.acquire();
	if (!scanningActive) {
		scanLock.release();
		return;
	}

	scanningActive = false;
	if (scanTimeout != undefined) {
		// This means that scanning isn't actively awaiting scanChannels. We can just cancel the timeout.
		clearTimeout(scanTimeout);
	} else {
		// This means that we need to actively wait for an ongoing scan to finish
		const scanStopPromise = new Promise<void>((resolve) => {
			scanStopped = resolve;
		});
		await (scanStopPromise);
	}
	loginfo("User Phidget scanning Stopped");
	scanLock.release();
}

export function managerDeviceAttach(dev: Device) {
	for (const m of Managers)
		m._deviceAttach(dev);
}

export function managerDeviceDetach(dev: Device) {
	for (const m of Managers)
		m._deviceDetach(dev);
}

export function managerChannelAttach(ch: Channel) {
	for (const m of Managers)
		m._channelAttach(ch);
}

export function managerChannelDetach(ch: Channel) {
	for (const m of Managers)
		m._channelDetach(ch);
}
